import { API_ROUTES } from "../../utils/constants";
import { AxiosBase } from "./index";

export default class AuthService extends AxiosBase {
  login = async (body) => {
    try {
      const response = await this.requests.post(
        `${API_ROUTES.AUTHENTICATION.LOGIN_AUTH}`,
        body
      );
      return response;
    } catch (err) {
      throw err;
    }
  };
  logout = async (body) => {
    try {
      const response = await this.requests.post(
        `${API_ROUTES.AUTHENTICATION.LOGOUT_AUTH}`,
        body
      );
      return response;
    } catch (err) {
      throw err;
    }
  };
  getPermission = async () => {
    try {
      const response = await this.requests.get(
        `${API_ROUTES.USERMANAGEMENT.GET_USER_PERMISSIONS}`
      );
      return response;
    } catch (err) {
      if (err?.response?.status === 401) {
        throw err;
      }
      throw err;
    }
  };

  mfaVerifyLogin = async (body) => {
    try {
      const response = await this.requests.post(
        `${API_ROUTES.AUTHENTICATION.MFA_VERIFY_LOGIN}`,
        body
      );
      return response;
    } catch (err) {
      throw err;
    }
  };

  mfaSetup = async () => {
    try {
      const response = await this.requests.post(
        `${API_ROUTES.AUTHENTICATION.MFA_SETUP}`
      );
      return response;
    } catch (err) {
      throw err;
    }
  };

  mfaVerifySetup = async (body) => {
    try {
      const response = await this.requests.post(
        `${API_ROUTES.AUTHENTICATION.MFA_VERIFY_SETUP}`,
        body
      );
      return response;
    } catch (err) {
      throw err;
    }
  };

  mfaDisable = async (body) => {
    try {
      const response = await this.requests.post(
        `${API_ROUTES.AUTHENTICATION.MFA_DISABLE}`,
        body
      );
      return response;
    } catch (err) {
      throw err;
    }
  };

  mfaRegenerateBackupCodes = async (body) => {
    try {
      const response = await this.requests.post(
        `${API_ROUTES.AUTHENTICATION.MFA_REGENERATE_BACKUP_CODES}`,
        body
      );
      return response;
    } catch (err) {
      throw err;
    }
  };

}
